import { Usuario } from "../usuario";
import { Estado } from "../estado";
import { ContraparteGrupo } from "../contraparte-grupo";
import { ContraparteCCEE } from "../contraparte-ccee";
import { ContraparteContato } from "..";
import { Auditable } from "../auditable";

export enum ContraparteStatus {
  ATIVO = "A",
  INATIVO = "I",
}

export enum ContraparteTipo {
  MATRIZ = "M",
  FILIAL = "F",
}

export enum ContraparteClassificacao {
  CASA_DE_GESTAO = "Casa de Gestão",
  CLIENTE = "Cliente",
  COMERCIALIZADORA_INDEPENDENTE = "Comercializadora Independente",
  DISTRIBUIDORA = "Distribuidora",
  GRANDES_GRUPOS = "Grandes Grupos",
  RENOVAVEIS = "Renováveis",
}

export interface Contraparte extends Auditable {
  readonly id?: number | null;
  readonly aliquotaICMS?: number | null;
  readonly bairro?: string | null;
  readonly cep?: string | null;
  readonly cidade?: string | null;
  readonly classificacao?: string | null;
  readonly cnpj?: string | null;
  readonly complemento?: string | null;
  readonly endereco?: string | null;
  readonly idCCEE?: string | null;
  readonly grupo?: ContraparteGrupo | null;
  readonly idMatriz?: number | null;
  readonly filiais?: Contraparte[] | null;
  readonly usuario?: Usuario | null;
  readonly ie?: string | null;
  readonly im?: string | null;
  readonly ISS?: string | null;
  readonly nomeFantasia?: string | null;
  readonly numero?: string | null;
  readonly obs?: string | null;
  readonly razaoSocial?: string | null;
  readonly status?: ContraparteStatus | null;
  readonly tipo?: ContraparteTipo | null;
  readonly ccees?: ContraparteCCEE[] | null;
  readonly contatos?: ContraparteContato[] | null;
  readonly idUsuario?: number | null;
  readonly estado?: Estado | null;
  readonly empresaNegociacaoId?: string | null;
}
